module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/haircut-mobile@3x-79299f483c05428129b13560c582b47e.jpg";